import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export default class LocationOverviewTasksRoute extends Route {
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;

  titleToken = 'Tasks';

  beforeModel(): void {
    if (!this.featureFlags.isEnabled('ava-tasks-landing-page')) {
      void this.router.transitionTo('location-overview');
    }
  }
}
